export const FRIENDLY = 'Do MMM YYYY';
